module.exports = __webpack_public_path__ + "static/img/result_list.5e198539.png";